package com.vizio.redwolf.consent.model

import com.vizio.redwolf.auth.utils.TokenRefreshReason
import kotlin.js.JsExport

@JsExport
sealed class ARTokenState {
    object NothingUpdated : ARTokenState()
    data class AllTokensUpdated(val newAccessToken: String, val newAccessTokenExpiry: String, val newRefreshToken: String, val reason: TokenRefreshReason) : ARTokenState()

    fun <R> fold(
        onNothingUpdated: (nothingUpdated: NothingUpdated) -> R,
        onAllTokensUpdated: (allTokensUpdated: AllTokensUpdated) -> R
    ): R {
        return when (this) {
            is AllTokensUpdated -> onAllTokensUpdated(AllTokensUpdated(this.newAccessToken, this.newAccessTokenExpiry, this.newRefreshToken, this.reason))
            NothingUpdated -> onNothingUpdated(NothingUpdated)
        }
    }
}